<template>
  <v-dialog v-model="dialog" persistent max-width="520" scrollable :fullscreen="$store.getters.mobile" content-class="anular-modal">
    <ValidationObserver ref="form" tag="div">
      <v-card :key="key" class="anular">
        <div class="anular__encabezado">
          <v-icon color="white" class="mr-2">mdi-close-circle-outline</v-icon>
          <span class="anular__titulo">{{ $t("anulate_order") }}</span>
          <v-spacer></v-spacer>
          <v-btn color="white" icon @click="$emit('close')" :title="$t('Cancel')">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>

        <v-card-text class="anular__cuerpo">
          <p class="anular__aviso" v-if="message">{{ message }}</p>
          <div class="anular__resumen" v-if="order && order.getTotalItems">
            <span>{{ Math.ceil(order.getTotalItems()) }} {{ Math.ceil(order.getTotalItems()) === 1 ? "producto" : "productos" }}</span>
            <strong>{{ $filters.currency(order.getPriceTotalWithAdds(), 0) }}</strong>
          </div>

          <div class="anular__etiqueta">Motivo</div>
          <div class="anular__motivos">
            <button type="button" v-for="m in motivos" :key="m.id" class="anular__motivo"
              :class="{ 'anular__motivo--elegido': motivo && motivo.id === m.id }" @click="motivo = m">
              {{ m.name }}
            </button>
          </div>
          <p class="anular__efecto" v-if="motivo">
            <v-icon x-small>mdi-information-outline</v-icon> {{ etiquetaTratamiento(motivo.treatment) }}
          </p>

          <ng-textarea-keyboard
            v-model="item.reason"
            class="mt-3"
            :label="motivo && motivo.requires_note ? 'Nota (obligatoria)' : 'Nota (opcional)'"
          ></ng-textarea-keyboard>
          <p class="anular__error" v-if="error">{{ error }}</p>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions class="anular__pie">
          <v-btn text large @click="$emit('close')">{{ $t("Cancel") }}</v-btn>
          <v-btn large depressed color="error" class="anular__confirmar" :disabled="!puedeAnular || anulando" :loading="anulando" @click="annulOrder">
            {{ $t("anulate_order") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </ValidationObserver>
  </v-dialog>
</template>
<style>
.anular__encabezado {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  height: 56px;
  padding: 0 8px 0 16px;
  color: #fff;
  background: #d32f2f;
}

.anular__titulo {
  font-size: 1.2rem;
  font-weight: 500;
}

.anular__aviso {
  margin: 4px 0 10px;
  font-size: 1rem;
}

.anular__resumen {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 14px;
  margin-bottom: 14px;
  border-radius: 10px;
  background: #fdecea;
  color: rgba(0, 0, 0, 0.8);
}

.anular__resumen strong {
  font-size: 1.15rem;
}

.anular__etiqueta {
  margin-bottom: 8px;
  font-size: 0.78rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: rgba(0, 0, 0, 0.6);
}

.anular__motivos {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 8px;
}

.anular__motivo {
  min-height: 44px;
  padding: 8px 10px;
  border: 1.5px solid rgba(0, 0, 0, 0.15);
  border-radius: 10px;
  background: #fff;
  font-size: 0.9rem;
  font-weight: 500;
  line-height: 1.2;
  text-align: center;
  cursor: pointer;
}

.anular__motivo:hover {
  border-color: #d32f2f;
}

.anular__motivo--elegido {
  border-color: #d32f2f;
  background: #fdecea;
  color: #b71c1c;
  font-weight: 700;
}

.anular__efecto {
  margin: 8px 0 0;
  font-size: 0.82rem;
  color: rgba(0, 0, 0, 0.6);
}

.anular__error {
  margin: 8px 0 0;
  font-size: 0.85rem;
  color: #d32f2f;
}

.anular__pie {
  gap: 8px;
  padding: 10px 12px calc(10px + env(safe-area-inset-bottom)) !important;
}

.anular__confirmar {
  flex: 1 1 auto;
  min-height: 48px !important;
  font-weight: 700;
}
</style>
<script>
import NgTextareaKeyboard from '../../../gui/NgTextareaKeyboard.vue';
export default {
  components: { NgTextareaKeyboard },
  name: "CartAnnulOrder",
  data: () => ({
    searched: false,
    key: 0,
    item: { reason: "" },
    motivos: [],
    motivo: null,
    anulando: false,
    error: "",
  }),
  computed: {
    // Con motivo elegido, y con nota si ese motivo la pide.
    puedeAnular() {
      if (!this.motivo) return false;
      return !this.motivo.requires_note || (this.item.reason || "").trim().length >= 3;
    },
  },
  watch: {
    dialog(abierto) {
      if (abierto) {
        this.motivo = null;
        this.item.reason = "";
        this.error = "";
        this.cargarMotivos();
      }
    },
  },
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    order: Object,
    message: {
      type: String,
      default: "",
    },
  },

  mounted() {},
  methods: {
    async cargarMotivos() {
      try {
        const r = await this.$http.get("api/v1/pos/motivos-de-anulacion", {});
        this.motivos = (r && r.items) || [];
      } catch (e) {
        this.motivos = [];
      }
    },
    etiquetaTratamiento(valor) {
      return {
        none: "Sin efecto en inventario",
        inventory_loss: "Se registra como pérdida",
        receivable: "Queda por cobrar",
        charge_waiter: "Se marca para descontar al responsable",
      }[valor] || "";
    },
    async annulOrder(order){
      const actual = this.$pos.getCurrentOrder();
      const nota = (this.item.reason || "").trim();
      // Un pedido que ya está en el servidor se anula con el motivo del catálogo; uno que solo está en esta
      // pantalla se anula como siempre, con el texto del motivo.
      if (actual.id) {
        this.anulando = true;
        this.error = "";
        try {
          const r = await this.$http.post("api/v1/order/change-status/" + actual.id, {
            order_status: "annulled",
            time: this.$filters.currentDatetime(),
            reason_id: this.motivo.id,
            reason: nota,
          });
          if (!r || !r.success) {
            this.error = (r && (r.message || r.msg)) || "No se pudo anular el pedido.";
            return;
          }
        } catch (e) {
          this.error = (e && (e.message || e.msg)) || "No se pudo anular el pedido. Revisa la conexión e inténtalo de nuevo.";
          return;
        } finally {
          this.anulando = false;
        }
        actual.setCanceled(true);
        actual.setCancellationDate(this.$filters.datetime(new Date()));
        actual.setCancellationReason(nota ? this.motivo.name + ": " + nota : this.motivo.name);
        actual.setIsOpen(false);
        actual.setOrderStatus('annulled');
        this.$pos.notifyChangeInOrder();
        this.$emit('annul', order);
        return;
      }
      actual.setCanceled(true)
      actual.setCancellationDate(this.$filters.datetime((new Date())))
      actual.setCancellationReason(nota ? this.motivo.name + ": " + nota : this.motivo.name)
      actual.setIsOpen(false)
      actual.setOrderStatus('annulled')
      this.$pos.notifyChangeInOrder();
      this.$pos.saveOrder(actual, this.$http);

      this.$emit('annul', order);
    },
    cancel() {
      this.$emit("cancel");
    }

  },
};
</script>